import { graphql } from "react-relay";

export const RemoveTemplateMutation = graphql`
  mutation RemoveTemplateMutation($name: String!) {
    removeTemplate(name: $name) @deleteRecord
  }
`;
